const LANGUAGE_CODES = {
  'en-US': ['en-us', 'en-gb', 'en-au'],
  'zh-HK': ['zh-hk', 'yue-hk'],
  'zh-CN': ['zh-cn', 'zh-sg']
}

const PREFERRED_NAMES = {
  'en-US': [
    'microsoft aria online',
    'microsoft jenny online',
    'microsoft guy online',
    'google us english',
    'samantha',
    'ava',
    'alex',
    'daniel',
    'karen',
    'moira',
    'serena'
  ],
  'zh-HK': ['sin-ji', 'cantonese', 'hong kong', 'hiugaai', 'hiumaan', '廣東', '粤語', '粵語'],
  'zh-CN': ['ting-ting', 'mei-jia', 'yu-shu', 'mandarin', 'xiaoxiao', 'yunxi', 'huihui', 'yaoyao', '普通話', '普通话']
}

const EFFECT_VOICE = /bad news|bahh|bells|boing|bubbles|cellos|jester|organ|superstar|trinoids|whisper|wobble|zarvox/i

export function defaultSpeechRate (language) {
  return language === 'en-US' ? 0.85 : 1
}

export function getVoices () {
  return window.speechSynthesis ? window.speechSynthesis.getVoices() : []
}

export function findVoice (language, voices = getVoices()) {
  const languages = LANGUAGE_CODES[language] || [language.toLowerCase()]
  const compatibleVoices = voices.filter(voice => languages.includes(voice.lang.toLowerCase()))
  const preferredVoice = (PREFERRED_NAMES[language] || [])
    .map(name => compatibleVoices.find(voice => voice.name.toLowerCase().includes(name)))
    .find(Boolean)
  const normalVoice = compatibleVoices.find(voice => !EFFECT_VOICE.test(voice.name))

  return preferredVoice || normalVoice || compatibleVoices[0] || null
}
